import { downloadFramedPng, svgImage } from "../../../../../utils/chartExport";
import { pieSvg } from "./mapModel";

export const MAP_CREDIT = "Map data © OpenStreetMap contributors";

/**
 * The map as the user sees it, on a canvas: the basemap tiles where they sit
 * on screen, then each pie drawn from the same SVG as its marker, largest
 * first so small sites stay on top as they do on the map. The tiles load with
 * CORS (crossOrigin on the tile layers), so the canvas can be saved.
 */
const drawMap = async (map, pies, scale) => {
  const container = map.getContainer();
  const box = container.getBoundingClientRect();
  const { x: width, y: height } = map.getSize();
  const canvas = document.createElement("canvas");
  canvas.width = width * scale;
  canvas.height = height * scale;
  const ctx = canvas.getContext("2d");
  ctx.scale(scale, scale);
  ctx.fillStyle = "#f2efe9";
  ctx.fillRect(0, 0, width, height);

  container
    .querySelectorAll(".leaflet-tile-pane img.leaflet-tile-loaded")
    .forEach((tile) => {
      const r = tile.getBoundingClientRect();
      ctx.drawImage(
        tile,
        r.left - box.left,
        r.top - box.top,
        r.width,
        r.height,
      );
    });

  const order = [...pies].sort((a, b) => b.radius - a.radius);
  const images = await Promise.all(order.map((pie) => svgImage(pieSvg(pie))));
  order.forEach((pie, i) => {
    const point = map.latLngToContainerPoint(pie.position);
    const { width: w, height: h } = images[i];
    if (
      point.x + w / 2 < 0 ||
      point.y + h / 2 < 0 ||
      point.x - w / 2 > width ||
      point.y - h / 2 > height
    )
      return;
    ctx.drawImage(images[i], point.x - w / 2, point.y - h / 2, w, h);
  });
  return { canvas, width, height };
};

/** Download the map's current view as a PNG, framed like every chart. */
export const downloadMapPng = async ({
  map,
  pies,
  title,
  subtitle,
  legend,
  scale = 2,
}) => {
  const { canvas, width, height } = await drawMap(map, pies, scale);
  try {
    await downloadFramedPng({
      image: canvas,
      width,
      height,
      title,
      subtitle,
      legend,
      credit: MAP_CREDIT,
      scale,
    });
  } catch (err) {
    // a tile served without CORS taints the canvas
    if (err?.name === "SecurityError")
      throw new Error(
        "The map image could not be made: the map tiles did not allow it",
      );
    throw err;
  }
};
